let assignHeights = function() {
  const heightOrigin = document.querySelector('[data-height-set]')
  document.documentElement.style.setProperty('--fixed-header-height', `${heightOrigin.offsetHeight}px`);
}

export default assignHeights;